import { render, staticRenderFns } from "./SettingRandomQuestion.vue?vue&type=template&id=3bd27c00"
import script from "./SettingRandomQuestion.vue?vue&type=script&lang=js"
export * from "./SettingRandomQuestion.vue?vue&type=script&lang=js"
import style0 from "./SettingRandomQuestion.vue?vue&type=style&index=0&id=3bd27c00&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports